import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import FaqsList from './FaqsList'
import FaqProfile from './FaqProfile'

export default function Faqs() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/faqs" component={FaqsList} />
				<Route exact path="/faqs/:id" component={FaqProfile} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}